export interface MediaAttachment {
    fileName: string;
    path: string;
    mediaType: MediaType;
}

export enum MediaType {
    image = 'image',
    video = 'video',
    audio = 'audio',
    voice = 'voice',
    document = 'document'
}